import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function getList(params) {
  return request({
    url: URL.jobContainerNo.getList,
    method: 'get',
    params
  })
}
